import React, { useState } from "react";
import Book from "./book/Book";
import Novel from "./novel/Novel";
import { regenerateCustomStoryImage } from "../../../api/customAPI";
import ImageComparisonModal from "../../utils/modal/ImageComparisonModal";
import "../../../styles/components/selectbook/Result.scss";

export default function Result({
  type,
  sceneImages,
  storyPrompt,
  setIsChangeLoading,
  user_id,
  character_job_id,
  getImageStatus,
  storyId,
}) {
  const [story, setStory] = useState(() => {
    if (!storyPrompt || !sceneImages) return [];
    return storyPrompt.map((prompt, i) => ({
      image_url: sceneImages[i]?.url || "",
      page_content: prompt.page_content || "",
      applied_content: prompt.page_content || "",
      page_id: prompt.page_id,
    }));
  });

  const [index, setIndex] = useState(0);
  const [showFinalModal, setShowFinalModal] = useState(false);

  const [showComparisonModal, setShowComparisonModal] = useState(false);
  const [comparisonData, setComparisonData] = useState({
    oldImage: "",
    newImage: "",
    oldContent: "",
    newContent: "",
  });

  const handleChangeBackground = async (overriddenContent = null) => {
    setIsChangeLoading(true);

    const targetContent =
      typeof overriddenContent === "string"
        ? overriddenContent
        : story[index].page_content;

    const res = await regenerateCustomStoryImage({
      user_id: user_id,
      character_job_id: character_job_id,
      scene_index: story[index].page_id,
      page_content: targetContent,
    });

    if (res.success) {
      const imageStatus = await getImageStatus(res.data.batch_id);

      if (imageStatus && imageStatus.success) {
        setComparisonData({
          oldImage: story[index].image_url,
          newImage: imageStatus.data.images[0].url,
          oldContent: story[index].applied_content,
          newContent: targetContent,
        });
        setShowComparisonModal(true);
      }
    }
    setIsChangeLoading(false);
  };

  const handleApplyNewImage = () => {
    const newStory = [...story];
    newStory[index].image_url = comparisonData.newImage;
    newStory[index].applied_content = comparisonData.newContent;
    newStory[index].page_content = comparisonData.newContent;
    setStory(newStory);
    setShowComparisonModal(false);
  };

  const handleCancelNewImage = () => {
    const newStory = [...story];
    newStory[index].page_content = story[index].applied_content;
    setStory(newStory);
    setShowComparisonModal(false);
  };

  return (
    <>
      {type === "picture_book" || type === "그림 동화" ? (
        <Book
          story={story}
          setStory={setStory}
          setIndex={setIndex}
          index={index}
          showFinalModal={showFinalModal}
          setShowFinalModal={setShowFinalModal}
          handleChangeBackground={handleChangeBackground}
          user_id={user_id}
          character_job_id={character_job_id}
          storyPrompt={storyPrompt}
          storyId={storyId}
        />
      ) : type === "graphic_novel" || type === "그림 소설" ? (
        <Novel
          story={story}
          setStory={setStory}
          pageCount={story.length}
          showFinalModal={showFinalModal}
          setShowFinalModal={setShowFinalModal}
          handleChangeBackground={handleChangeBackground}
          setIndex={setIndex}
          user_id={user_id}
          character_job_id={character_job_id}
          storyPrompt={storyPrompt}
          storyId={storyId}
        />
      ) : (
        <div className="error-wrap">
          데이터를 불러올 수 없습니다. (Type: {type})
        </div>
      )}

      {showComparisonModal && (
        <ImageComparisonModal
          oldImage={comparisonData.oldImage}
          newImage={comparisonData.newImage}
          oldContent={comparisonData.oldContent}
          newContent={comparisonData.newContent}
          onApply={handleApplyNewImage}
          onCancel={handleCancelNewImage}
        />
      )}
    </>
  );
}
